// libraries
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import type { DealHistory } from '@makemydeal/dr-dash-types';

// components
import { Grid } from '@interstate/components/Grid';
import DealSummaryItem from '../common/DealSummaryItem';
import LineItemWithChildren from '../common/LineItemWithChildren';

// constants
import * as constants from '../../constants';

// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';

// utils
import { formatDollarsAndCents, formatNumber } from '@makemydeal/dr-common-utils';
import { useHeldValue } from '../../hooks/useHeldSelector';

export type TotalResidualProps = {
    deal?: DealHistory;
    useWrapper?: boolean;
    hasDelta?: boolean;
};

const TotalResidual = ({ deal }: TotalResidualProps) => {
    const useDealRootSelector = createDealRootSelector(deal, 'TotalResidual');
    const adjustedResidualAmount = useHeldValue(
        useDealRootSelector(offerReduxSelectors.getAdjustedResidualValue, 'adjustedResidualValue'),
        deal
    );
    const totalResidual = formatDollarsAndCents(adjustedResidualAmount); // showing dollar regardless of selected override type
    const baseResidualAmount = useHeldValue(
        useDealRootSelector(offerReduxSelectors.getBaseResidualDollar, 'baseResidualDollar'),
        deal
    );
    const baseResidualPercent = useHeldValue(
        useDealRootSelector(offerReduxSelectors.getBaseResidualPercent, 'baseResidualPercent'),
        deal
    );
    const milesPerYear: number = useHeldValue(
        useDealRootSelector(offerReduxSelectors.getAnnualMilesByTerm, 'annualMilesByTerm'),
        deal
    );
    const existingMileage = useDealRootSelector(vehicleSelectors.getMileage, 'mileage');

    return (
        <DealSummaryItem label={constants.TOTAL_RESIDUAL} value={totalResidual}>
            <Grid>
                <LineItemWithChildren label={constants.BASE_RESIDUAL_LABEL} value={formatDollarsAndCents(baseResidualAmount)} />
                <LineItemWithChildren label={constants.MILES_PER_YEAR} value={formatNumber(milesPerYear)} />
                <LineItemWithChildren label={constants.EXISTING_MILEAGE} value={formatNumber(existingMileage)} />
                <br />
                <LineItemWithChildren label={constants.BASE_RESIDUAL_PERCENT} value={`${baseResidualPercent}%`} />
            </Grid>
        </DealSummaryItem>
    );
};

export default TotalResidual;
